<template>
  <div class="video-list">
    <div class="video-list__seasons-section" v-if="this.filterType=='season'">
      <a href="#" class="child" v-for="season in seasons" :key="season" @click.prevent="selectSeason(season)" :class="{ selected : isSeasonSelected(season) }">
        <h2>Season {{ season }}</h2>
      </a>
      <a href="#" class="child child--side-button" @click.prevent="changeFilterType('tag')"><h2>Tags</h2></a>
    </div>
    <div class="video-list__seasons-section" v-if="this.filterType=='tag'">
      <a href="#" class="child" v-for="tag in tags" :key="tag" @click.prevent="selectTag(tag)" :class="{ selected : isTagSelected(tag) }">
        <h2>{{ tag }}</h2>
      </a>
      <a href="#" class="child child--side-button" @click.prevent="changeFilterType('season')"><h2>Seasons</h2></a>
    </div>
    <perfect-scrollbar class="scroll-container">
      <div class="video-list__list">
        <div class="video-list__episode" v-for="(video, index) in videoList" :key="index" @click="selectEpisode(video.videoUrl)">
          <div class="video-list__episode-thumbnail" :style="{ backgroundImage: `url('${getVideoThumbnail(video)}')`}" ></div>
          <h4>Episode {{ video.order }}</h4>
          <h3>{{ video.title }}</h3>
          <p>{{ video.description }}</p>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<style lang="scss" scoped>
.video-list {
  position: relative;
  padding: 12px 47px 64px 47px;
  height: 75vh;

  &__list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  &__episode {
    cursor: pointer;
    margin: 16px;
    &-thumbnail {
      width: 100%;
      padding-bottom: 56%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }

    h4 {
      color: #fc8b00;
      font-size: 1.25em;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 12px;
      text-transform: uppercase;
      margin: 18px 0 0 0;
    }

    h3 {
      color: #ffffff;
      font-size: 1.5em;
      font-weight: 700;
      letter-spacing: 1.85px;
      line-height: 20px;
      text-transform: uppercase;
      margin: 9px 0 0 0;
      padding-right: 32px;
    }

    p {
      color: #ffffff;
      font-size: 1em;
      font-weight: 300;
      line-height: 16px;
      margin: 14px 0 0 0;
      padding-right: 32px;
    }
  }

  &__seasons-section {
    position: relative;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    .child {
      margin: 0 36px;
      &:hover,
      &:visited,
      &:active {
        text-decoration: none;
      }
      h2 {
        color: #ffffff;
        font-size: 1.25em;
        font-weight: 700;
        line-height: 20px;
        text-transform: uppercase;
      }

      &.selected {
        h2 {
          color: #fc8b00;
        }
      }

      &--side-button {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        h2 {
          font-size: 1em;
        }
      }
    }
  }

  &__controls {
    @extend .material-icons;
    position: absolute;
    background-color: #fc8b00;
    padding: 12px;
    font-size: 36px;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.25);
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }
  }
  .scroll-container {
    height: calc(75vh - 60px);
  }
}
</style>

<script>
import utils from '../../utils'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      currentEpisode: 0,
      selectedSeason: null,
      selectedTag: null,
      filterType: 'season'
    }
  },
  props: {
    closeAction: {
      type: Function,
      required: false
    }
  },
  computed: {
    videoList () {
      const filter = item => { return (this.selectedSeason === null || item.season === this.selectedSeason) && (this.selectedTag === null || (item.filters && item.filters.includes(this.selectedTag))) }
      return this.$store.state.videoList.filter(filter)
    },
    filterList () {
      return this.$store.state.filterList
    },
    maxPages () {
      return Math.floor(this.videoList.length / 4)
    },
    currentIndex () {
      return this.$store.state.currentVideo
    },
    hasVideos () {
      return this.$store.getters.hasVideos
    },
    currentVideo () {
      return this.hasVideos ? this.videoList[this.currentIndex] : this.$store.getters.emptyEpisode
    },
    seasons () {
      return new Set(this.$store.state.videoList.map(x => x.season))
    },
    tags () {
      return new Set(this.$store.state.filterList)
    }
  },
  watch: {
    seasons: function (val) {
      this.selectedSeason = Array.from(val)[0]
    }
  },
  methods: {
    getVideoThumbnail (video) {
      const videoId = utils.getVideoIdFromYoutubeUrl(video.videoUrl)
      return videoId ? `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg` : ''
    },
    nextEpisode () {
      this.$refs.videoList.handleNavigation('forward')
    },
    previousEpisode () {
      this.$refs.videoList.handleNavigation('backward')
    },
    selectEpisode (url) {
      this.$store.commit('setCurrentVideo', url)
      if (this.closeAction) {
        this.closeAction()
      }
    },
    selectSeason (season) {
      if (this.selectedSeason !== season) {
        this.selectedSeason = season
        //  this.$refs.videoList.goToPage(0)
      } else if (this.selectedSeason !== null) {
        this.selectedSeason = null
        //  this.$refs.videoList.goToPage(0)
      }
    },
    selectTag (tag) {
      if (this.selectedTag !== tag) {
        this.selectedTag = tag
        //  this.$refs.videoList.goToPage(0)
      } else if (this.selectedTag !== null) {
        this.selectedTag = null
        //  this.$refs.videoList.goToPage(0)
      }
    },
    isSeasonSelected (season) {
      return this.selectedSeason === season
    },
    isTagSelected (tag) {
      return this.selectedTag === tag
    },
    changeFilterType (type) {
      if (type === 'tag') {
        this.filterType = 'tag'
        this.selectedSeason = null
      } else {
        this.filterType = 'season'
        this.selectedTag = null
        this.selectedSeason = Array.from(this.seasons)[0]
      }
    }
  }
}
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
